/* eslint-disable max-len */
import { usersList } from "./apiSlice";

export const providersList=usersList.injectEndpoints({
    tagTypes:['Provider','AssociatedProviderOrg', 'SelectedOrg', 'OrganizationList','AssociatedProviderPatient'],
    endpoints:(builder)=>({
        getProviders: builder.query({
            query: (searchParams) => `providers?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Provider',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Provider', id:_id}))
            ]:[]
            
        }),
        // add provider journey
        addProvider:builder.mutation({
            query:org=>({
                url:`providers`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['Provider']
        }),
        // view provider journey
        viewProvider: builder.query({    
            query: (id) => `/providers/${id}`,
            providesTags: (result, error, arg) => [{ type: 'Provider', id: arg }]    
        }),
        // edit provider journey
        editProvider:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/providers/${id}`:`/providers/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Provider', id: arg.id },'ProviderHistory']
        }),
        exportProviders:builder.mutation({
            query: ({ sort, columns, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `providers/export-provider-list?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "dateformat": dateformat , "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        // activity history
        getProviderActivityHistory: builder.query({
            query: (searchParams) => `providers/list-changes?${searchParams}`,
            providesTags: ['ProviderHistory']

        }), 
        // export activity history for provider
        exportProviderActivityHistory:builder.mutation({
            query:({sort,columns,username,dateformat ,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return{
                    url:`providers/export-activity-history?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"target_user_name":username,"dateformat":dateformat, "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        // view export history
        getProviderExportHistory: builder.query({
            query: (searchParams) => `providers/view-export-history${searchParams !== undefined ? `?${searchParams}` : ""}`,
            providesTags: ['ProviderHistory']
        }), 
        // export history for export activity
        exportProviderExportHistory: builder.mutation({
            query: ({ sort, columns, username, dateformat }) => ({
                url: `providers/export-export-history?target_user_name=${encodeURIComponent(username)}`,
                method: 'POST',
                body: {
                    "columns": columns,
                    "dateformat": dateformat,
                    "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            }),
        }),
        exportPatientsAssociatedToProvider: builder.mutation({
            query: ({ queryString,columns,dateformat,provider_id }) => ({
                url: `providers/export-patients/${provider_id}${queryString!==''?`?${queryString}`:''}`,
                method: 'POST',
                body: {
                    "columns": columns,
                    "dateformat": dateformat,
                    "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            }),
        }),
        exportOrgAssociatedToProvider: builder.mutation({
            query: ({ columns,dateformat,provider_id }) => ({
                url: `providers/export-organization/${provider_id}`,
                method: 'POST',
                body: {
                    "columns": columns,
                    "dateformat": dateformat,
                    "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            }),
        }),
        // for organization listing
        getOrganizations: builder.query({
            query: (searchParams) => `organizations?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'OrganizationList',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'OrganizationList', id:_id}))
            ]:[],
            // invalidatesTags:['SelectedOrg']

        }),
        // for getting subdivision of that organization
        getSubdivisions: builder.query({
            query: (organizationName) => `providers/link-organisation?${organizationName}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'SelectedOrg',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SelectedOrg', id:_id}))
            ]:[], 

        }),
        // link provider with organization
        linkProvidertoOrganization: builder.mutation({
            query: (payload) => ({
                url: `providers/organization`,
                method: 'POST',
                body:payload
            }),
            // invalidatesTags: ['SelectedOrg','OrganizationList']
        }),
        // for getting associated organizations and subdivisons
        getAssociatedOrganizations: builder.query({
            query: (searchParams) => `providers/organization?&${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderOrg',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'AssociatedProviderOrg', id:_id}))
            ]:[],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        getAssociatedPatients: builder.query({
            query: (searchParams) => `providers/list-linked-patients?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'AssociatedProviderPatient', id:_id}))
            ]:[],
        }),
        deleteAssociatedOrganization: builder.mutation({
            query: ({id, userName}) => {
                return {
                    url: `providers/organization?id=${id}&target_user_name=${userName}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [
                { type: 'AssociatedProviderOrg', id: arg.id }, // Invalidate AssociatedProviderOrg
                'AssociatedProviderPatient',                 // Invalidate all AssociatedProviderPatient tags
            ],
        }),
        getPatientAssociatedProvider: builder.query({
            query: (searchParams) => `providers/list-linked-patients${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'AssociatedProviderPatient', id:_id}))
            ]:[],
        }),
        deletePatientAssociatedToProvider: builder.mutation({
            query: ({patient_id,provider_id}) => {
                return {
                    url: `patients/unlink-provider/${patient_id}?provider_id=${provider_id}&tab=provider`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'AssociatedProviderPatient', id: arg.id }],
        }),
        // provider associated patient list
        getProviderAssociatedPatientList: builder.query({
            query: (queryParamsPassed) => `providers/${queryParamsPassed}`,
            providesTags:(result=[],error,arg)=>error===undefined?[    
                'patient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'patient', id:_id}))
            ]:[]
            
        }),
        // associating patient list
        associatePatientToProvider:builder.mutation({
            query:({providerId,body})=>({
                url:`providers/${providerId}/patients`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['patient','AssociatedProviderPatient']
        }),
    }),
    overrideExisting: false
})


export const {
    useGetProvidersQuery,
    useAddProviderMutation,
    useViewProviderQuery,
    useEditProviderMutation, 
    useExportProvidersMutation,
    useGetProviderActivityHistoryQuery,
    useExportProviderActivityHistoryMutation ,
    useGetProviderExportHistoryQuery,
    useExportProviderExportHistoryMutation,
    useGetOrganizationsQuery,
    useLazyGetSubdivisionsQuery,
    useLinkProvidertoOrganizationMutation,
    useLazyGetAssociatedOrganizationsQuery,
    useLazyGetAssociatedPatientsQuery,
    useDeleteAssociatedOrganizationMutation,
    useLazyGetPatientAssociatedProviderQuery,
    useDeletePatientAssociatedToProviderMutation,
    useExportPatientsAssociatedToProviderMutation,
    useExportOrgAssociatedToProviderMutation,
    useLazyViewProviderQuery,
    useGetProviderAssociatedPatientListQuery,
    useAssociatePatientToProviderMutation,
}=providersList